<script>
    import clsx from './../common/clsx/index'
</script>

<div class="{clsx('el-button-group',$$props['class'])}" style={$$props['style']}>
    <slot />
</div>